export const digitalClock = (ms) => {
    const validMs = ms < 0 ? 0 : ms;
    return [
        Math.floor(validMs / 3600000),
        Math.floor((validMs % 3600000) / 60000)
            .toString()
            .padStart(2, "0"),
        Math.floor(((validMs % 360000) % 60000) / 1000)
            .toString()
            .padStart(2, "0"),
    ]
        .filter(Boolean)
        .join(":");
};
//# sourceMappingURL=digitalClock.js.map